import React, { Ref } from "react";
import { BookCheck } from "lucide-react";

import { Account } from "../../../api/accounts";
import {
  EntityPopover,
  EntityPopoverHandle,
} from "../../../components/ui/popover/EntityPopover";
import AccountPopoverRow from "./AccountPopoverRow";

export interface AccountsPopoverProps {
  accounts: Account[];
  ref?: Ref<EntityPopoverHandle>;
}

export const AccountsPopover: React.FC<AccountsPopoverProps> = ({
  accounts,
  ref,
}) => {
  return (
    <EntityPopover
      ref={ref}
      icon={<BookCheck width={16} />}
      title="Accounts"
      items={accounts.map((account, index) => ({
        content: (
          <AccountPopoverRow account={account} showDivider={index > 0} />
        ),
        copyValue: account.ext_account_number,
      }))}
    />
  );
};
